import * as actions from '../constants';
var initialState = [];
export var products = function products() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.USER_PRODUCTS_LOAD_SUCCESS:
      return action.payload;

    case actions.LOG_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};